/* This unpublished theme intentionally has no cart, checkout or entry API writes. */
(() => {
  'use strict';
  const themeId = document.body.dataset.themeId;
  const currency = document.body.dataset.currency || 'USD';
  const storageKey = `theian-preview-bag-${themeId}-${currency}`;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
  const clampQty = n => Math.min(10, Math.max(1, Math.floor(Number(n) || 1)));
  const cart = document.getElementById('th-cart');
  const promotion = {threshold:Number(cart?.dataset.rewardThreshold)||0,reward:Number(cart?.dataset.rewardEntries)||0,multiplier:Number(cart?.dataset.entryMultiplier)||1,bonus:Number(cart?.dataset.campaignBonus)||0};
  const count = n => n.toLocaleString('en-US');
  const finishFor = item => ['bronze','platinum','gold','obsidian'].includes(item.finish)?item.finish:item.price>=50000?'obsidian':item.price>=25000?'gold':item.price>=10000?'platinum':'bronze';
  /* Pure cart arithmetic: the unlock is derived, never a persisted paid item. */
  function cartSummary(items, threshold, reward) {
    const subtotal=items.reduce((sum,item)=>sum+item.price*item.qty,0);
    const itemEntries=items.reduce((sum,item)=>sum+(Number.isSafeInteger(item.entries)?item.entries*item.qty:0),0);
    const rewardEnabled=Number.isSafeInteger(threshold)&&threshold>0&&Number.isSafeInteger(reward)&&reward>0;
    const unlocked=rewardEnabled&&subtotal>=threshold;
    return {subtotal,itemEntries,unlocked,reward:unlocked?reward:0,entries:itemEntries+(unlocked?reward:0),itemCount:items.reduce((sum,item)=>sum+item.qty,0),remaining:Math.max(0,threshold-subtotal),progress:rewardEnabled?Math.min(100,subtotal/threshold*100):0,rewardEnabled};
  }
  function choosePackage(packages, items, remaining) {
    const candidates=packages.filter(p=>!items.some(item=>item.id===p.id)).sort((a,b)=>a.price-b.price);
    const current=Math.max(0,...items.filter(item=>item.kind==='digital').map(item=>item.price));
    return candidates.find(p=>p.price>=remaining&&p.price>current)||candidates.find(p=>p.price>current)||candidates[0];
  }
  /* End pure cart arithmetic. */
  const digitalPackages = () => [...document.querySelectorAll('[data-entry-option]')].map(option=>({id:'entry-'+option.value,title:option.dataset.title,price:Number(option.dataset.price),entries:Number(option.dataset.entries),finish:option.dataset.entryFinish,kind:'digital',qty:1})).filter(item=>Number.isSafeInteger(item.price)&&item.price>=5000&&Number.isSafeInteger(item.entries)&&item.entries>=0);
  function prepareItem(item) {
    const authored=digitalPackages().find(p=>p.id===item.id);
    if(authored)return {...item,...authored,qty:clampQty(item.qty)};
    if(item.kind==='digital'||item.id.startsWith('entry-'))return {...item,kind:'digital',finish:finishFor(item)};
    // Entry packs carry their own count. Do not replace it with the Shared Sweep math.
    const fixed=Number(item.entries);
    if(item.entryFixed===true&&Number.isSafeInteger(fixed)&&fixed>=0)return {...item,kind:'product',entries:fixed,entryFixed:true};
    // Same count as the product badge: floor(dollars × Shared Sweep multiplier) + that product's bonus.
    // The old 200X campaign rate is not used here.
    const dollars=item.priceOverride===true&&Number(item.entryBase)>0?Number(item.entryBase):item.price/100;
    const shopMult=Number(cart?.dataset.sweepMultiplier)||1;
    const chosen=Number(item.entryMult);
    const mult=chosen>0?chosen:shopMult;
    const bonus=Number.isFinite(Number(item.entryBonus))?Math.max(0,Math.floor(Number(item.entryBonus))):0;
    const entries=currency==='USD'?Math.floor(dollars*mult)+bonus:undefined;
    return {...item,kind:'product',entryMult:mult,entryBonus:bonus,entries:Number.isSafeInteger(entries)?entries:undefined};
  }
  // Reads the badge on the product being added, so a higher product multiplier is kept.
  function sweepFrom(node) {
    const section=node?.closest?.('.product-single, .th-product-page, [data-product-root], .th-pdp-details, [data-theian-watch-pdp]');
    const badge=section?.querySelector('.ss-entries-badge');
    if(!badge)return {};
    const wrap=badge.closest('.ss-entries-wrap-price');
    const mult=Number(badge.dataset.mult);
    const bonus=Number(badge.dataset.bonus);
    const base=Number(badge.dataset.base);
    return {entryMult:mult>0?mult:undefined,entryBonus:Number.isFinite(bonus)?bonus:0,entryBase:base>0?base:undefined,priceOverride:wrap?.dataset.priceOverride==='true'};
  }
  let bag = [];
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) bag = saved.filter(x => x && typeof x.id === 'string' && typeof x.title === 'string' && Number.isFinite(x.price) && x.price >= 0).slice(0, 50).map(x => ({...x, qty:clampQty(x.qty)}));
  } catch (_) { /* Storage may be unavailable in private browsing. */ }
  bag=bag.map(prepareItem);
  const announce = message => { const el = document.querySelector('[data-announcement]'); if (el) el.textContent = message; };
  const make = (tag, className, text) => { const el = document.createElement(tag); if (className) el.className = className; if (text !== undefined) el.textContent = text; return el; };
  const saveBag = (removedId) => { try { sessionStorage.setItem(storageKey, JSON.stringify(bag)); } catch (_) {} renderBag(); enqueueShopify(() => syncShopify(removedId)).catch(error => info('Unable to complete your request', cartErrorText(error))); };
  // The drawer used to keep its own bag. These calls write that bag into the Shopify cart.
  let shopifyQueue = Promise.resolve();
  function enqueueShopify(task) {
    shopifyQueue = shopifyQueue.catch(() => {}).then(task);
    return shopifyQueue;
  }
  function cartErrorText(error) {
    const message = error && error.message;
    if (message && message !== 'cart') return message;
    return 'Please try again or contact THEIAN for assistance.';
  }
  function cartEndpoint(kind) {
    const addUrl = cart?.dataset.cartAdd || '/cart/add.js';
    if (kind === 'add') return addUrl;
    if (kind === 'clear') return cart?.dataset.cartClear || '/cart/clear.js';
    return addUrl.replace(/add\.js$/, kind + '.js');
  }
  function writeCart(kind, body) {
    return fetch(cartEndpoint(kind), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    }).then(async response => {
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || 'cart');
      return data;
    });
  }
  function syncShopify(removedId) {
    const updates = {};
    bag.forEach(item => { if (/^\d+$/.test(String(item.id))) updates[String(item.id)] = item.qty; });
    if (removedId && /^\d+$/.test(String(removedId))) updates[String(removedId)] = 0;
    const ids = Object.keys(updates);
    if (!ids.length) return Promise.resolve();
    return writeCart('update', { updates }).then(state => {
      const missing = bag.filter(item => /^\d+$/.test(String(item.id)) && !(state.items || []).some(line => String(line.variant_id) === String(item.id)));
      if (!missing.length) return state;
      return writeCart('add', { items: missing.map(item => ({ id: Number(item.id), quantity: item.qty })) });
    });
  }
  function summary(){return cartSummary(bag,currency==='USD'?promotion.threshold:0,promotion.reward);}
  // Footer total is the sum of each product's own entries. The unlock bonus is not added.
  function renderEntryTotal(){const row=document.querySelector('[data-cart-entry-total]');const number=document.querySelector('[data-cart-entry-count]');if(!row||!number)return;const total=summary();row.hidden=!total.itemEntries;number.textContent=count(total.itemEntries);}
  function renderCartCount(){const value=String(bag.reduce((sum,item)=>sum+item.qty,0));document.querySelectorAll('[data-cart-count],.js-cart-count').forEach(el=>{if(el.textContent!==value)el.textContent=value;});}
  function ticketArt(item,gift=false){
    const art=make('div','th-cart-ticket');art.dataset.finish=gift?'reward':finishFor(item);art.setAttribute('aria-hidden','true');
    art.append(make('span','','THEIAN'),make('strong','',gift?'BONUS\nENTRIES':'QUICK\nENTRY'));
    return art;
  }
  function productImageURL(src,baseURL){
    if(typeof src!=='string'||!src.trim())return '';
    try{
      const base=new URL(baseURL),url=new URL(src,base);
      // Shopify image_url uses the current storefront host, including shared previews.
      const trusted=url.origin===base.origin||['https://cdn.shopify.com','https://theiangrown.com','https://www.theiangrown.com','https://theia-opulence.myshopify.com'].includes(url.origin);
      return url.protocol==='https:'&&!url.username&&!url.password&&trusted?url.href:'';
    }catch(_){return '';}
  }
  function productArt(item){
    const img=make('img','th-cart-product-image');
    const src=productImageURL(item.image,location.href);if(src)img.src=src;
    img.alt=item.title;img.loading='lazy';return img;
  }
  // Option name plus the value the shopper picked. Older bag items only have the joined title.
  function selectedOptions(product, variant) {
    if (!variant) return [];
    const names = Array.isArray(product?.options) ? product.options.map(option => typeof option === 'string' ? option : option?.name).filter(Boolean) : [];
    return [variant.option1, variant.option2, variant.option3].filter(value => value && value !== 'Default Title').map((value, index) => ({ name: names[index] || '', value }));
  }
  function appendSelectedOptions(copy, item) {
    let options = Array.isArray(item.options) ? item.options.filter(option => option && option.value && option.value !== 'Default Title') : [];
    if (!options.length && item.variant && item.variant !== 'Default Title' && !item.variant.includes('—')) {
      options = String(item.variant).split(' / ').map(value => value.trim()).filter(Boolean).map(value => ({ name: '', value }));
    }
    if (!options.length) return;
    // Values with no name read as one line: "18K Gold / 7\" / Moissanite".
    const named = options.some(option => option.name);
    if (!named) {
      copy.append(make('p', 'th-cart-option-line', options.map(option => option.value).join(' / ')));
      return;
    }
    // Named choices stay stacked, one plain line each: "Diamond size: 1.5 ct. tw."
    const list = make('ul', 'th-cart-options');
    options.forEach(option => {
      const row = make('li');
      row.append(make('span', '', option.name + ':'));
      row.append(make('strong', '', option.value));
      list.append(row);
    });
    copy.append(list);
  }
  function rewardUI(total){
    const root=cart?.querySelector('[data-cart-reward]');if(!root)return;
    root.hidden=!total.rewardEnabled;root.dataset.unlocked=String(total.unlocked);
    root.querySelector('[data-cart-reward-label]').textContent=count(promotion.reward)+' EXTRA ENTRIES';
    const progress=root.querySelector('[data-cart-progress]');progress.style.setProperty('--progress',total.progress+'%');progress.setAttribute('aria-valuenow',String(Math.round(total.progress)));
    const message=total.unlocked?`You’ve unlocked ${count(promotion.reward)} extra entries. On us.`:`Add ${money(total.remaining)} to unlock ${count(promotion.reward)} extra entries.`;
    progress.setAttribute('aria-valuetext',message);root.querySelector('[data-cart-reward-message]').textContent=message;
    root.querySelector('[data-cart-offer-check]').dataset.active=String(bag.length>0);
    root.querySelector('[data-cart-reward-check]').textContent=total.unlocked?'✓':'✦';
  }
  let cartProducts=[];
  try{const data=JSON.parse(cart?.querySelector('[data-cart-products]')?.textContent||'[]');if(Array.isArray(data))cartProducts=data.filter(item=>typeof item.id==='string'&&typeof item.title==='string'&&Number.isSafeInteger(item.price)&&item.price>0);}catch(_){}
  function renderRecommendations(total){
    const target=cart?.querySelector('[data-cart-recommendation-items]');if(!target)return;
    target.replaceChildren();
    const next=choosePackage(digitalPackages(),bag,total.remaining);
    const suggestions=[...(next?[next]:[]),...cartProducts.filter(p=>!bag.some(item=>item.id===p.id)).slice(0,2)];
    cart.querySelector('[data-cart-recommendations]').hidden=!suggestions.length;
    suggestions.forEach(item=>{
      const row=make('article','th-cart-recommendation'),copy=make('div','th-cart-recommendation-copy');
      row.append(item.kind==='digital'?ticketArt(item):productArt(item));
      copy.append(make('h4','',item.kind==='digital'?`${item.title.replace(/^The /,'')} · ${count(item.entries)} entries`:item.title),make('p','th-cart-recommendation-price',money(item.price)));
      let action;
      if(item.chooseOptions){action=make('a','th-cart-recommendation-add','Options');const url=new URL(item.url,location.href);url.searchParams.set('preview_theme_id',themeId);action.href=url.href;action.setAttribute('aria-label',`Choose options for ${item.title}`);}
      else{action=make('button','th-cart-recommendation-add','Add');action.type='button';action.setAttribute('aria-label',`Add ${item.title}`);action.addEventListener('click',()=>{addPreviewItem({type:item.kind==='digital'?'th-digital-preview-add':'th-catalog-preview-add',detail:{...item,qty:1}});cart.querySelector('[data-close-dialog]')?.focus({preventScroll:true});});}
      row.append(copy,action);target.append(row);
    });
  }
  function renderBag() {
    renderCartCount();
    const target = document.querySelector('[data-cart-items]');
    if (!target) return;
    target.replaceChildren();
    const total=summary();
    if (!bag.length) target.append(make('p', 'th-empty-bag', 'Your next chapter starts here. Choose a ticket or something worth keeping.'));
    bag.forEach(item => {
      const row = make('div', 'th-cart-line');row.dataset.cartItem=item.id;
      const copy = make('div','th-cart-line-copy');
      copy.append(make('h3', '', item.title));
      appendSelectedOptions(copy, item);
      let badge;
      if(Number.isSafeInteger(item.entries)){
        badge=make('span','th-cart-entry-badge');
        const countBox=make('span','th-cart-entry-count');
        countBox.append(make('span','th-cart-entry-value',count(item.entries*item.qty)),make('span','th-cart-entry-label','Entries'));
        badge.append(countBox);
      }
      const controls=make('div','th-cart-line-controls'),stepper=make('div','th-cart-stepper');
      const qty = make('input'); qty.type = 'number'; qty.min = '1'; qty.max = '10'; qty.value = item.qty;qty.inputMode='numeric';qty.dataset.cartQty=item.id; qty.setAttribute('aria-label', `Quantity for ${item.title}`);
      const updateQty=(value)=>{item.qty=clampQty(value);saveBag();[...target.querySelectorAll('[data-cart-qty]')].find(input=>input.dataset.cartQty===item.id)?.focus({preventScroll:true});};
      qty.addEventListener('input', () => {if(qty.value!==''&&Number.isFinite(Number(qty.value)))updateQty(qty.value);});
      qty.addEventListener('change', () => updateQty(qty.value));
      const minus=make('button','','−'),plus=make('button','','+');minus.type=plus.type='button';minus.disabled=item.qty<=1;plus.disabled=item.qty>=10;
      minus.setAttribute('aria-label',`Decrease quantity for ${item.title}`);plus.setAttribute('aria-label',`Increase quantity for ${item.title}`);
      minus.addEventListener('click',()=>updateQty(item.qty-1));plus.addEventListener('click',()=>updateQty(item.qty+1));
      stepper.append(minus,qty,plus);
      controls.append(make('strong','th-cart-line-price',money(item.price*item.qty)));
      if(badge)controls.append(badge);
      controls.append(stepper);copy.append(controls);
      const remove = make('button', 'th-cart-remove', '×'); remove.type = 'button'; remove.setAttribute('aria-label', `Remove ${item.title}`);
      remove.addEventListener('click', () => { const removedId = item.id; bag = bag.filter(x => x.id !== removedId); saveBag(removedId); announce('Item removed from bag.');cart.querySelector('[data-close-dialog]')?.focus({preventScroll:true}); });
      row.append(item.kind==='digital'?ticketArt(item):productArt(item),copy,remove);
      target.append(row);
    });
    document.querySelector('[data-cart-total]').textContent = money(total.subtotal);
    const label=cart?.querySelector('[data-cart-subtotal-label]');if(label)label.textContent=`Total (${total.itemCount} ${total.itemCount===1?'item':'items'})`;
    renderRecommendations(total);
    renderEntryTotal();
    // An empty bag stays disabled. Any other theme can check out, not only the old test theme.
    const checkout=cart?.querySelector('[data-test-checkout-start]');if(checkout)checkout.disabled=!total.itemCount||total.subtotal<=0;
    document.dispatchEvent(new CustomEvent('th-bag-updated',{detail:{items:bag.map(item=>({id:item.id,qty:item.qty}))}}));
  }
  let cartReturnFocus,cartCloseTimer;
  function openDialog(dialog) { if (dialog && !dialog.open) {if(dialog===cart){cartReturnFocus=document.activeElement;clearTimeout(cartCloseTimer);cart.classList.remove('is-closing');renderBag();document.body.classList.add('th-cart-open');}dialog.showModal();if(dialog===cart){cart.querySelector('.th-cart-scroll').scrollTop=0;cart.querySelector('[data-close-dialog]').focus({preventScroll:true});}} }
  function closeDialog(dialog){
    if(!dialog)return;
    if(dialog!==cart||window.matchMedia('(prefers-reduced-motion: reduce)').matches){dialog.close();return;}
    if(cart.classList.contains('is-closing'))return;
    cart.classList.add('is-closing');cartCloseTimer=setTimeout(()=>cart.close(),180);
  }
  cart?.addEventListener('cancel',event=>{event.preventDefault();closeDialog(cart);});
  cart?.addEventListener('close',()=>{clearTimeout(cartCloseTimer);cart.classList.remove('is-closing');document.body.classList.remove('th-cart-open');if(cartReturnFocus?.isConnected)cartReturnFocus.focus({preventScroll:true});});
  // Real products are also written to the Shopify cart. Preview packages have no variant id, so they stay in the drawer only.
  function addPreviewItem(event) {
    let item=event.detail;
    if(!item || typeof item.id!=='string' || typeof item.title!=='string' || !Number.isSafeInteger(item.price) || item.price<0)return;
    if(event.type==='th-digital-preview-add' && (item.price<5000 || !Number.isSafeInteger(item.entries) || item.entries<0))return;
    item=prepareItem(item);
    const existing=bag.find(x=>x.id===item.id);
    if(existing)existing.qty=clampQty(existing.qty+clampQty(item.qty));
    else bag.push({...item,qty:clampQty(item.qty)});
    saveBag();announce('Added to bag.');openDialog(document.getElementById('th-cart'));
  }
  document.addEventListener('th-digital-preview-add',addPreviewItem);
  document.addEventListener('th-catalog-preview-add',addPreviewItem);
  function startTestCheckout(){
    const total=summary();if(!total.itemCount||total.subtotal<=0)return;
    // The older preview theme still opens its own checkout screen.
    if(themeId==='190141235243'){
      if(cart?.open)cart.close();
      document.dispatchEvent(new CustomEvent('th-test-checkout-open',{detail:{currency,subtotal:total.subtotal,entries:total.itemEntries,items:bag.map(({title,price,qty})=>({title,price,qty}))}}));
      return;
    }
    // Real products use their variant id. Preview-only packages are not Shopify variants.
    const shopItems=bag.filter(item=>/^\d+$/.test(String(item.id)));
    if(!shopItems.length){info('Unable to complete your request','Please try again or contact THEIAN for assistance.');return;}
    const button=cart?.querySelector('[data-test-checkout-start]');
    if(button)button.disabled=true;
    const checkoutUrl=cart?.dataset.checkoutUrl||'/checkout';
    // Replace the Shopify cart with this bag, then open checkout.
    enqueueShopify(() => writeCart('clear').then(() => writeCart('add', { items: shopItems.map(item => ({ id: Number(item.id), quantity: item.qty })) })))
      .then(() => location.assign(checkoutUrl))
      .catch(error => { if(button)button.disabled=false; info('Unable to complete your request', cartErrorText(error)); });
  }
  cart?.querySelector('[data-test-checkout-start]')?.addEventListener('click',startTestCheckout);
  document.addEventListener('th-test-checkout-request',startTestCheckout);
  document.addEventListener('th-test-return-to-bag',()=>openDialog(cart));
  function info(title, body) {
    document.getElementById('th-info-title').textContent = title;
    document.querySelector('#th-info [data-info-body]').textContent = body;
    openDialog(document.getElementById('th-info'));
  }
  // Third-party watch pages keep a normal variant picker, but the button must fill this bag.
  function addWatchProduct(button) {
    const root = button.closest('[data-theian-watch-pdp]');
    if (!root || button.disabled) return;
    let data;
    try { data = JSON.parse(root.querySelector('[data-thw-product]')?.textContent || ''); } catch (_) { data = null; }
    const id = root.querySelector('[name="id"]')?.value;
    const variant = data?.variants?.find(item => String(item.id) === String(id));
    if (!variant || variant.available === false || typeof data.title !== 'string' || !Number.isSafeInteger(variant.price)) {
      info('Unable to complete your request', 'Please try again or contact THEIAN for assistance.');
      return;
    }
    const qty = clampQty(root.querySelector('[name="quantity"]')?.value || 1);
    const image = (typeof variant.image === 'string' && variant.image) || (typeof data.image === 'string' && data.image) || '';
    let imageURL = '';
    try { if (image) imageURL = new URL(image, location.href).href; } catch (_) {}
    const existing = bag.find(item => item.id === String(variant.id));
    if (existing) existing.qty = clampQty(existing.qty + qty);
    else bag.push(prepareItem({id:String(variant.id), title:data.title, variant:variant.title, options:selectedOptions({options:data.options}, variant), price:variant.price, qty, image:imageURL, ...sweepFrom(root)}));
    saveBag(); announce('Added to bag.'); openDialog(document.getElementById('th-cart'));
  }
  // Entry pack cards are real products. The button adds that variant, with the count printed on the card.
  function addEntryPack(button) {
    if (button.disabled) return;
    const id = button.dataset.id;
    const title = button.dataset.title;
    const price = Number(button.dataset.price);
    const entries = Number(String(button.dataset.entries || '').replace(/,/g, ''));
    if (!/^\d+$/.test(String(id || '')) || !title || !Number.isSafeInteger(price) || price < 0) {
      info('Unable to complete your request', 'Please try again or contact THEIAN for assistance.');
      return;
    }
    let imageURL = '';
    try { if (button.dataset.image) imageURL = new URL(button.dataset.image, location.href).href; } catch (_) {}
    const existing = bag.find(item => item.id === String(id));
    if (existing) existing.qty = clampQty(existing.qty + 1);
    else bag.push(prepareItem({id:String(id), title, price, qty:1, image:imageURL, entries, entryFixed:Number.isSafeInteger(entries)}));
    saveBag(); announce('Added to bag.'); openDialog(document.getElementById('th-cart'));
  }
  document.addEventListener('th-native-preview', event => {
    if(event.detail.kind === 'bag') { openDialog(document.getElementById('th-cart')); return; }
    const form = event.detail.target.closest('form');
    const source = document.getElementById('th-native-product-json');
    let product;
    try { product = JSON.parse(source?.textContent || 'null'); } catch (_) {}
    const id = form?.querySelector('[name="id"]')?.value;
    const variant = product?.variants.find(v => String(v.id) === String(id));
    if(variant?.available) {
      const qty=clampQty(form.querySelector('[name="quantity"]')?.value || 1);
      const existing=bag.find(x=>x.id===String(variant.id));
      if(existing)existing.qty=clampQty(existing.qty+qty);
      else bag.push(prepareItem({id:String(variant.id),title:product.title,variant:variant.title,options:selectedOptions(product,variant),price:variant.price,qty,image:new URL(variant.featured_image?.src||product.featured_image||'',location.href).href,...sweepFrom(form)}));
      saveBag();openDialog(document.getElementById('th-cart'));
    } else info('Unable to complete your request', 'Please try again or contact THEIAN for assistance.');
  });
  function preservePreview(root = document) {
    root.querySelectorAll('a[href]').forEach(link => {
      const raw = link.getAttribute('href');
      if (!raw || /^(#|mailto:|tel:)/i.test(raw)) return;
      try {
        const url = new URL(raw, location.href);
        if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return;
        if (/^\/(cart|checkout)(\/|$)/.test(url.pathname)) return;
        url.searchParams.set('preview_theme_id', themeId);
        link.href = url.toString();
      } catch (_) {}
    });
  }
  function setupProduct(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    let product;
    try { product = JSON.parse(root.dataset.productJson); } catch (_) { return; }
    const select = root.querySelector('[data-variant-select]');
    const add = root.querySelector('[data-preview-add]');
    const variantFromURL = new URL(location.href).searchParams.get('variant');
    let variant = product.variants.find(v => String(v.id) === String(select?.value || variantFromURL)) || product.variants.find(v => v.available) || product.variants[0];
    function showImage(src, alt) {
      const image = root.querySelector('.th-main-image');
      if (!image || !src) return;
      image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = src; image.alt = alt || product.title;
    }
    root.querySelectorAll('[data-gallery-image]').forEach(button => button.addEventListener('click', () => {
      showImage(button.dataset.galleryImage, button.dataset.imageAlt);
      root.querySelectorAll('[data-gallery-image]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    }));
    function renderVariant(updateURL = false) {
      if (!variant) { add.disabled = true; return; }
      root.querySelector('[data-product-price]').textContent = money(variant.price);
      root.querySelector('[data-product-compare]').textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      root.querySelector('[data-product-sku]').textContent = variant.sku || 'Not supplied';
      add.disabled = !variant.available;
      add.textContent = variant.available ? 'Add to bag ↗' : 'Currently unavailable';
      if (variant.featured_image?.src) showImage(variant.featured_image.src, product.title);
      if (updateURL) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url); }
    }
    select?.addEventListener('change', () => { variant = product.variants.find(v => String(v.id) === select.value); renderVariant(true); });
    add?.addEventListener('click', () => {
      if (!variant?.available) return;
      const qty = clampQty(root.querySelector('[data-product-quantity]').value);
      const existing = bag.find(x => x.id === String(variant.id));
      if (existing) existing.qty = clampQty(existing.qty + qty);
      else bag.push(prepareItem({id:String(variant.id), title:product.title, variant:variant.title, options:selectedOptions(product, variant), price:variant.price, qty, image:new URL(variant.featured_image?.src || product.featured_image || '', location.href).href, ...sweepFrom(root)}));
      saveBag(); announce('Added to bag.'); openDialog(document.getElementById('th-cart'));
    });
    renderVariant();
  }
  function setupCollection(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-sort-grid]');
    if (!grid) return;
    const cards = [...grid.children]; cards.forEach((card,index) => { card.dataset.order = index; });
    root.querySelectorAll('[data-filter-brand]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-filter-brand]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      cards.forEach(card => { card.hidden = button.dataset.filterBrand !== 'all' && card.dataset.vendor !== button.dataset.filterBrand; });
      root.querySelector('[data-filter-status]').textContent = `${cards.filter(card => !card.hidden).length} watches shown`;
    }));
    root.querySelector('[data-product-sort]')?.addEventListener('change', event => {
      const mode = event.target.value;
      const sorted = [...cards].sort((a,b) => mode === 'price-asc' ? Number(a.dataset.price)-Number(b.dataset.price) : mode === 'price-desc' ? Number(b.dataset.price)-Number(a.dataset.price) : mode === 'title' ? a.dataset.title.localeCompare(b.dataset.title) : Number(a.dataset.order)-Number(b.dataset.order));
      sorted.forEach(card => grid.append(card));
    });
  }
  document.addEventListener('click', event => {
    const watchAdd = event.target.closest('[data-thw-add],[data-thw-sticky-add]');
    if (watchAdd) { event.preventDefault(); addWatchProduct(watchAdd); return; }
    const packAdd = event.target.closest('[data-thg-add]');
    if (packAdd) { event.preventDefault(); addEntryPack(packAdd); return; }
    if(event.target.closest('.js-toggle-cart')){event.preventDefault();event.stopImmediatePropagation();openDialog(cart);return;}
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.matches('[data-open-cart]')) openDialog(document.getElementById('th-cart'));
    if (target.matches('[data-close-dialog]')) closeDialog(target.closest('dialog'));
    if (target.matches('[data-info-title]')) info(target.dataset.infoTitle, target.dataset.infoBody);
    if (target.matches('[data-menu-toggle]')) {
      const open = target.getAttribute('aria-expanded') !== 'true';
      target.setAttribute('aria-expanded', String(open)); target.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.getElementById('th-navigation').classList.toggle('is-open', open);
    }
    if (target.closest('.th-navigation') && target.tagName === 'A') {
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      document.getElementById('th-navigation').classList.remove('is-open');
    }
    if (target.tagName === 'A') {
      const url = new URL(target.href, location.href);
      if (url.origin === location.origin && /^\/(cart|checkout)(\/|$)/.test(url.pathname)) { event.preventDefault(); event.stopImmediatePropagation(); openDialog(document.getElementById('th-cart')); }
    }
  }, true);
  document.addEventListener('submit', event => {
    event.preventDefault(); event.stopImmediatePropagation();
    if (event.target.matches('[data-preview-newsletter]')) {
      event.target.querySelector('[data-newsletter-status]').textContent = 'We couldn’t process your request. Please try again.';
      event.target.reset();
    } else info('Unable to complete your request', 'Please try again or contact THEIAN for assistance.');
  }, true);
  document.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog); } }));
  document.addEventListener('keydown', event => {
    if(event.target.closest('.js-toggle-cart')&&['Enter',' '].includes(event.key)){event.preventDefault();openDialog(cart);return;}
    if (event.key === 'Escape') { document.getElementById('th-navigation')?.classList.remove('is-open'); document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded','false'); }
  });
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setupFilm(video) {
    if (video.dataset.filmInitialized) return;
    video.dataset.filmInitialized = 'true';
    const surface = video.closest('.th-cinema,.tc-hero');
    const toggle = surface?.querySelector('[data-film-toggle]');
    let visible = true, userPaused = false, explicitPlay = false;
    video.muted = true;
    const sync = () => {
      if (!toggle) return;
      toggle.hidden = false;
      toggle.textContent = video.paused ? 'Play film ▷' : 'Pause film Ⅱ';
      toggle.setAttribute('aria-label', video.paused ? 'Play background film' : 'Pause background film');
    };
    const update = () => {
      if (!visible || document.hidden || userPaused || (reducedMotion.matches && !explicitPlay)) video.pause();
      else video.play().catch(sync);
      sync();
    };
    video.addEventListener('playing', () => { video.classList.add('is-ready'); sync(); });
    video.addEventListener('pause', sync);
    video.addEventListener('error', sync);
    toggle?.addEventListener('click', () => {
      if (video.paused) { userPaused = false; explicitPlay = true; }
      else { userPaused = true; explicitPlay = false; }
      update();
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }, {threshold:0.05});
      observer.observe(video);
    }
    document.addEventListener('visibilitychange', update);
    reducedMotion.addEventListener('change', update);
    update();
  }
  function setupReveals(root) {
    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), {threshold:0.06,rootMargin:'0px 0px -20px 0px'});
    root.querySelectorAll('.th-section-heading,.th-product-card,.th-monthly-copy,.th-story-copy,.tc-card,.tc-scarcity-left,.tc-scarcity-right,.tc-diamonds-card').forEach(el => {
      if (el.classList.contains('th-reveal')) return;
      el.classList.add('th-reveal'); observer.observe(el);
    });
  }
  const updateHeader = () => document.body.classList.toggle('th-scrolled', window.scrollY > 35);
  const cartCountObserver='MutationObserver' in window?new MutationObserver(renderCartCount):null;
  window.addEventListener('scroll', updateHeader, {passive:true});
  function init(root = document) {
    root.querySelectorAll('.js-toggle-cart').forEach(toggle=>{toggle.setAttribute('role','button');toggle.tabIndex=0;toggle.setAttribute('aria-label','Open shopping bag');toggle.setAttribute('aria-haspopup','dialog');toggle.setAttribute('aria-controls','th-cart');});
    root.querySelectorAll('.js-cart-count').forEach(counter=>{if(!counter._thCountWatched&&cartCountObserver){cartCountObserver.observe(counter,{childList:true,characterData:true,subtree:true});counter._thCountWatched=true;}});
    preservePreview(root);
    root.querySelectorAll('[data-product-root]').forEach(setupProduct);
    root.querySelectorAll('[data-collection-root]').forEach(setupCollection);
    root.querySelectorAll('[data-th-film]').forEach(setupFilm);
    setupReveals(root); updateHeader(); renderBag();
    // Copy a bag that was saved before cart sync existed into the Shopify cart.
    if (root === document && !init.bagSynced) { init.bagSynced = true; enqueueShopify(() => syncShopify()).catch(() => {}); }
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
